import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { PackageGrid } from "@/components/solutions/PackageGrid";

export default function ServicesPage() {
  return (
    <div className="pt-24 pb-16">
      <section className="py-16 hero-gradient">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <Badge variant="info" className="mb-4">
              Services
            </Badge>
            <h1 className="font-display text-4xl md:text-5xl font-bold mb-4">
              Desktop App Studio{" "}
              <span className="text-gradient">for Founders</span>
            </h1>
            <p className="text-xl text-muted-foreground mb-8">
              End-to-end packages for founders building AI-powered desktop apps.
              From blueprint and feasibility through full launch and ongoing
              release ops — flat fees and predictable retainers.
            </p>
          </motion.div>
        </div>
      </section>

      <div className="container mx-auto px-6 py-16">
        <PackageGrid />
      </div>
    </div>
  );
}
